import React, { useState } from "react";
import { Box, Stepper, Step, StepLabel, Paper } from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { useAuthStore } from "../../../store/useAuthStore";
import { useCaseCreationStore } from "../../../store/useCaseCreationStore";
import InformantDetails from "./informant-details/InformantDetails";
import DeceasedDetails from "./deceased-details/DeceasedDetails";
import RequestedServices from "./requested-services/RequestedServices";
import BodyLocation from "./body-location/BodyLocation";
import PackagePricing from "./package-pricing/PackagePricing";
import QuotationDocuments from "./quotation-documents/QuotationDocuments";
import { string } from "../../../constants/string";
import QuotationSuccess from "./submission-success/QuotationSuccess";

const steps = [
  "Informant Details",
  "Deceased Details",
  "Request Services",
  "Body Location",
  "Package / Pricing",
  "Documents",
];

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: "#E5E7EB", // light grey
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#F97316", // orange
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#F97316",
  },
}));

function CustomStepIcon(props: StepIconProps) {
  const { active, completed } = props;

  return (
    <Box
      sx={{
        width: 16,
        height: 16,
        borderRadius: "50%",
        backgroundColor: active || completed ? "#F97316" : "#D1D5DB",
        border: active ? "3px solid #F97316" : "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {active && (
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "#fff",
          }}
        />
      )}
    </Box>
  );
}

export default function CreateQuotation({ onSubmit }: any) {
  const [activeStep, setActiveStep] = useState(0);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const { informantDetails } = useCaseCreationStore();

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const onHandleSubmit = () => {
    onSubmit();
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <InformantDetails onNext={handleNext} />;
      case 1:
        return <DeceasedDetails onNext={handleNext} onBack={handleBack} />;
      case 2:
        return <RequestedServices onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <BodyLocation onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <PackagePricing onNext={handleNext} onBack={handleBack}/>;
      case 5:
        return <QuotationDocuments onNext={handleNext} onBack={handleBack}/>;
      case 6:
        return (
          <QuotationSuccess
          heading={string.quotation.heading}
          para={string.quotation.para}
          onHomeClick={isAuthenticated ? onHandleSubmit : null}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box>
      {/* Stepper */}
      {activeStep < 6 && (
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<CustomConnector />}
          sx={{ mb: 2, backgroundColor: "white", p: 2 }}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={CustomStepIcon}
                sx={{
                  "& .MuiStepLabel-label": {
                    fontWeight: 600,
                    fontSize: 16,
                    color: activeStep === index ? "#F97316" : "#111827",
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      )}

      {renderStepContent()}
    </Box>
  );
}
